<template>
  <div>
    <el-row>
      <el-col :span="12" v-if="Detail.workTypeName">
        <span class="label" style="min-width:60px">工作岗位:</span>
        <span class="context single_hide" style="max-width:500px" :title="Detail.workTypeName">{{Detail.workTypeName}}</span>
      </el-col>
      <el-col :span="12" v-if="Detail.employmentNumber">
        <span class="label">用工数量:</span>
        <span class="context">{{Detail.employmentNumber}}人</span>
      </el-col>
      <el-col :span="12" v-if="Detail.industryName">
        <span class="label">专业要求:</span>
        <span class="context">{{Detail.industryName}}{{Detail.categoryName?'/':''}}{{Detail.categoryName}}</span>
      </el-col>
      <el-col :span="12" v-if="employmentTime">
        <span class="label">用工时间:</span>
        <span class="context">{{employmentTime}}天</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      employmentTime:''
    }
  },
  props: {
    Detail: {
      type: Object
    }
  },
  components: {},
  created(){
    this.getDiffDay(this.Detail.startTime,this.Detail.endTime)
  },
  methods: {
    //计算日期间隔天数
     getDiffDay(date_1, date_2) {
      let startDate= moment(date_1).format('YYYY-MM-DD')
      let endDate= moment(date_2).format('YYYY-MM-DD')
      // 计算两个日期之间的差值
      let totalDays, diffDate
      let myDate_1 = Date.parse(startDate)
      let myDate_2 = Date.parse(endDate)
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
      if(totalDays===0){
        this.employmentTime=1
      }else{
        this.employmentTime=totalDays+1 // 相差的天数
      }   
    },
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .single_hide {
      // 单行隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
</style>
